import { __awaiter } from 'tslib';
import * as Long from 'long';
import { im_proto } from '../proto/index.js';
import { ErrorType } from '../core/consts.js';
import '../core/metrics/logger.js';
import { BaseError } from '../core/errors/BaseError.js';
import '../core/metrics/monitor.js';
import '../core/network/NetworkItem.js';
import { ServiceIdentity } from '../core/service/RuntimeContext.js';
import 'json-long';
import 'moize';
import '../core/model/Message.js';
import 'js-md5';
import '../core/utils/lz4.js';
import '../core/utils/serializer.js';
import '../adapter/manager/AdapterManager.js';
import '../adapter/manager/types.js';
import '../core/utils/ticker.js';
import '../adapter/abstract/IMNetApi.js';
import '../core/options.js';
import '../core/utils/uuid.js';
import '../core/service/ConversationManager.js';
import '../core/service/MessageManager.js';
import '@byted/uc-secure-sdk';
import '../core/plugin/DbProxy.js';
import '../core/metrics/trackerTypes.js';
import { BasePlugin } from '../core/plugin/BasePlugin.js';
import '../core/model/CommandMessage.js';

const KEY_MAP = new Map([
    [im_proto.IMCMD.SEND_MESSAGE, ['send_message_body', 'content', 'conversation_id', 'conversation_short_id']],
    [im_proto.IMCMD.CREATE_CONVERSATION_V2, ['create_conversation_v2_body', 'avatar_url', 'idempotent_id', 'name', 'participants']],
    [im_proto.IMCMD.ADD_CONVERSATION_PARTICIPANTS, ['conversation_add_participants_body', 'conversation_id', 'conversation_short_id', 'participants']]
]);
class SecurityPlugin extends BasePlugin {
    install() {
        this.register(ServiceIdentity.SecurityPlugin, this);
    }
    sendPacket(req) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.ctx.option.authType !== im_proto.AuthType.CERT_AUTH) {
                return req;
            }
            const authManager = this.resolve(ServiceIdentity.AuthManager);
            const certificate = authManager.getCert();
            if (certificate === false) {
                throw new BaseError({
                    ctx: this.ctx,
                    msg: 'Failed to get cert',
                    type: ErrorType.AuthSignError,
                    sender: this
                });
            }
            req.sdk_cert = certificate;
            const tsSign = authManager.getTsSign();
            if (tsSign === false) {
                throw new BaseError({
                    ctx: this.ctx,
                    msg: 'Failed to get ts_sign',
                    type: ErrorType.AuthSignError,
                    sender: this
                });
            }
            req.ts_sign = tsSign;
            if (KEY_MAP.has(req.cmd)) {
                const keys = KEY_MAP.get(req.cmd);
                const bodyKey = keys[0];
                const props = keys.slice(1);
                props.sort();
                const signData = [];
                props.forEach((prop) => {
                    var _a, _b;
                    const body = (_a = req.body) === null || _a === void 0 ? void 0 : _a[bodyKey];
                    const raw = (_b = body === null || body === void 0 ? void 0 : body[prop]) !== null && _b !== void 0 ? _b : '';
                    const value = Array.isArray(raw) ? raw.map(String).join(',') : Long.isLong(raw) ? String(raw) : raw;
                    signData.push(`${prop}=${value}`);
                });
                const { req_sign } = authManager.sign(signData.join('&'));
                req.reuqest_sign = req_sign;
            }
            return req;
        });
    }
}

export { SecurityPlugin };
//# sourceMappingURL=SecurityPlugin.js.map
